import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import * as Colors from 'ui-library/Colors';

export const LookupConfigModalPaneIndicator = ({
  paneIndex,
  useSchemaLanguage,
}: {
  paneIndex: number;
  useSchemaLanguage?: boolean;
}): JSX.Element => (
  <div className={classNames(css(styles.container))}>
    <div
      className={classNames(css(styles.paneNumber), {
        [css(styles.paneNumberActive)]: paneIndex === 0,
        [css(styles.paneNumberInactive)]: paneIndex !== 0,
      })}
    >
      1
    </div>
    <span className={paneIndex === 0 ? 'font-proxima-semibold' : ''}>
      {useSchemaLanguage ? 'Select schema' : 'Specify lookup object'}
    </span>
    <div className={css(styles.paneIndicatorLine)} />
    <div
      className={classNames(css(styles.paneNumber), {
        [css(styles.paneNumberActive)]: paneIndex === 1,
        [css(styles.paneNumberInactive)]: paneIndex !== 1,
      })}
    >
      2
    </div>
    <span className={paneIndex === 1 ? 'font-proxima-semibold' : ''}>
      {useSchemaLanguage ? 'Select field' : 'Specify lookup attribute'}
    </span>
  </div>
);

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    display: 'flex',
    lineHeight: '20px',
    fontSize: '13px',
  },
  paneIndicatorLine: {
    display: 'inline-block',
    borderTop: `1px solid ${Colors.GRAY}`,
    width: '60px',
    marginLeft: '6px',
    marginRight: '6px',
  },
  paneNumber: {
    display: 'inline-block',
    color: Colors.WHITE,
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    textAlign: 'center',
    lineHeight: '20px',
    marginRight: '6px',
  },
  paneNumberActive: {
    backgroundColor: Colors.BLUE_LIGHT,
  },
  paneNumberInactive: {
    backgroundColor: Colors.GRAY,
  },
});
